import React from 'react';

import SidebarItem from './components/SidebarItem';

import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import { useStyles } from './components/materialDesignStyles';
import { Drawer, List, IconButton, Divider } from '@material-ui/core';

import {
  ChevronRightIcon,
  ChevronLeftIcon,
  CreditCardIcon,
  UserClockIcon,
  UserIdIcon,
  PeopleGroupIcon,
  ArticleIcon,
  DomainIcon,
  LockClosedIcon,
  EnvelopeFlyingIcon,
  EnvelopeIcon,
  EnvelopeAtIcon,
  BillingInfoIcon,
  IntegrationsIcon,
  RadarIcon,
  PlanIcon,
  InvoiceIcon,
  UserDollarIcon,
  TrashCanIcon,
  InboxIcon,
  SigninIcon,
  HashIcon,
  FolderMultipleIcon,
  FolderIcon,
  MailboxFullIcon,
  FootballIcon,
  VaultIcon,
  HandShakeIcon,
  GraduationCapIcon,
  UserGroupIcon
} from '@stash-ui/regular-icons';

const SideBar = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawer = () => {
    setOpen(!open);
  };

  return (
    <div className={classes.root}>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawer}>{theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}</IconButton>
        </div>
        <Divider />
        <Divider />
        <List>
          <SidebarItem to="/users" icon={<UserIdIcon />} text="Users" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/channels" icon={<PeopleGroupIcon />} text="Channels" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/issues" icon={<ArticleIcon />} text="Issues" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/custom-senders" icon={<MailboxFullIcon />} text="Custom Senders" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/contact-bulk-actions" icon={<UserGroupIcon />} text="Contact Bulk Actions" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/api-connect-keys" icon={<VaultIcon />} text="API Connect Keys" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/short-link-domains" icon={<DomainIcon />} text="Short Link Domains" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/stripe-sync-buyers" icon={<CreditCardIcon />} text="Buyer Clients" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/education" icon={<GraduationCapIcon />} text="Education Courses" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/unique-lessons" icon={<GraduationCapIcon />} text="Unique Lessons" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/warmup-domains-rules" icon={<FootballIcon />} text="Warmup Domains" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/partners" icon={<HandShakeIcon />} text="Partners" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/recipients" icon={<UserDollarIcon />} text="Recipients" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/transactions" icon={<CreditCardIcon />} text="Transactions" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/invoices" icon={<InvoiceIcon />} text="Invoices" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/saasPlans" icon={<PlanIcon />} text="SaaS plans" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/paidSaas" icon={<InvoiceIcon />} text="Paid SaaS" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/landingPages" icon={<BillingInfoIcon />} text="Landing pages" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/integrations" icon={<IntegrationsIcon />} text="Integrations" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/custom-domains" icon={<DomainIcon />} text="Custom domains" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/ssl" icon={<LockClosedIcon />} text="SSLs" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/tags" icon={<HashIcon />} text="Tags" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/categories" icon={<FolderMultipleIcon />} text="Categories" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/asynctasks" icon={<RadarIcon />} text="Async tasks" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/email" icon={<EnvelopeAtIcon />} text="Email stats" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/sends" icon={<EnvelopeIcon />} text="Sends register" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/emailSends" icon={<EnvelopeFlyingIcon />} text="Email send" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/custom-template" icon={<FolderIcon />} text="Custom template" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/blackList" icon={<TrashCanIcon />} text="Black list" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/activities" icon={<UserClockIcon />} text="Activities" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/authRequests" icon={<SigninIcon />} text="Auth requests" />
        </List>
        <Divider />
        <List>
          <SidebarItem to="/webhooks" icon={<InboxIcon />} text="Webhooks actions" />
        </List>
        <Divider />
      </Drawer>
    </div>
  );
};
export default SideBar;
